const accountingHR = {
    "view": {
        "table": {
            "title": "Popis računovodstva",
            "column": {
                "release": "Izdanje",
                "period": "Razdoblje",
                "royalties": "Tantijemi",
                "costs": "Troškovi",
                "net_revenue": "Neto prihod",
                "status": "Status",
                "accounting_report": "Računovodstveno izvješće",
                "details": "Detalji"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "button": {
                "statusCreating": "Stvaranje",
                "statusGenerating": "Generiranje",
                "statusGenerated": "Generirano",
                "statusNotGenerated": "Nije generirano",
                "open": "Otvori",
                "downloadPDF": "Preuzmi PDF",
                "generatingPDF": "Generiranje PDF-a",
                "exportCsv": "Izvoz CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste koristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>obnovite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte podršku za više informacija."
        }
    },
    "add": {
        "form": {
            "label": {
                "filters": "Filteri",
                "monthRange": "Raspon mjeseca",
                "release": "Izdanje"
            },
            "options": {
                "allReleases": "Sva izdanja"
            },
            "placeholder": {
                "startingMonth": "Početni mjesec",
                "endingMonth": "Završni mjesec"
            },
            "button": {
                "generate": "Generiraj računovodstveno izvješće",
                "reset": "Resetiraj filtere"
            },
            "table": {
                "title": "Zarada dostupna za računovodstvo",
                "columns": {
                    "month": "Mjesec",
                    "year": "Godina",
                    "revenue": "Prihod",
                    "status": "Status"
                },
                "label": {
                    "status_open": "Otvoreno",
                    "status_accounted": "Evidentirano",
                    "month_january": "Siječanj",
                    "month_february": "Veljača",
                    "month_march": "Ožujak",
                    "month_april": "Travanj",
                    "month_may": "Svibanj",
                    "month_june": "Lipanj",
                    "month_july": "Srpanj",
                    "month_august": "Kolovoz",
                    "month_september": "Rujan",
                    "month_october": "Listopad",
                    "month_november": "Studeni",
                    "month_december": "Prosinac"
                }
            }
        },
        "modal": {
            "header": "Dodaj računovodstvo",
            "body": "Jeste li sigurni da želite dodati novo računovodstvo za Izdanje: {{release}}, RAZDOBLJE: {{startingMonth}} DO {{endingMonth}} ?"
        },
        "message": {
            "success": "Računovodstvo je stvoreno!",
            "errorSomethingWentWrong": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!",
            "errorNoEarningsAvailable": "Nema dostupne zarade za računovodstvo.",
            "errorNoReleaseSelected": "Molimo odaberite određeno izdanje za računovodstvo."
        }
    },
    "breakdown": {
        "view": {
            "table": {
                "title": "Raščlamba računovodstva",
                "column": {
                    "revenueShareHolder": "Dioničar",
                    "revenue": "Neto tantijemi dioničara",
                    "reportPdf": "Preuzmi PDF",
                    "action": "Akcija",
                    "emailSent": "Email poslan"
                },
                "label": {
                    "downloadPDF": "Preuzmi PDF",
                    "generatingPDF": "Generiranje PDF-a"
                },
                "button": {
                    "exportCsv": "Izvoz CSV"
                },
                "modal": {
                    "confirm": {
                        "header": "Pošalji izvješće dioničaru",
                        "body": "Jeste li sigurni da želite poslati izvješće dioničaru?",
                        "message": {
                            "success": "Izvješće uspješno poslano!"
                        },
                        "button": {
                            "cancel": "Otkaži",
                            "confirm": "Potvrdi"
                        }
                    }
                },
                "message": {
                    "success": "Računovodstveno izvješće je poslano!",
                    "errorSomethingWentWrong": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!",
                    "errorEmailNotPresent": "Email za dioničara nije prisutan!",
                    "errorNoReportAvailable": "Nema dostupnog izvješća za ovo izdanje."
                }
            }
        }
    }
};

export default accountingHR;